import { render, staticRenderFns } from "./sale-view-title.vue?vue&type=template&id=04b30d22&scoped=true&"
import script from "./sale-view-title.ts?vue&type=script&lang=ts&"
export * from "./sale-view-title.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b30d22",
  null
  
)

export default component.exports